<template>
  <div class="interview-invite">
    <div v-if="loading" class="loading">正在加载面试信息...</div>

    <div v-else class="container">
      <div class="header">
        <h2>面试邀请</h2>
        <p>您收到 {{ data.companyName }} 的面试邀请</p>
      </div>

      <div class="info-card">
        <div class="info-row">
          <div class="label">公司名称：</div>
          <div class="value">{{ data.companyName }}</div>
        </div>

        <div class="info-row">
          <div class="label">职位名称：</div>
          <div class="value">{{ data.jobName }}</div>
        </div>

        <div class="info-row">
          <div class="label">联系人：</div>
          <div class="value">{{ data.contactPerson }}</div>
        </div>

        <div class="info-row">
          <div class="label">联系电话：</div>
          <div class="value">{{ data.contactPhone }}</div>
        </div>

        <div class="info-row">
          <div class="label">面试时间：</div>
          <div class="value">{{ data.interviewTime }}</div>
        </div>

        <div class="info-row">
          <div class="label">面试地址：</div>
          <div class="value">{{ data.interviewLocation }}</div>
        </div>

        <div class="info-row">
          <button
            @click="data.interviewStatus == 8 ? confirmInterview() : ''"
            class="confirm-btn"
            :disabled="data.interviewStatus != 8"
          >
            确认参加
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      data: {}
    };
  },
  mounted() {
    this.fetchInterviewData();
  },
  methods: {
    fetchInterviewData() {
      this.req(
        "/party/getInterviewInfo",
        { interviewId: this.$route.query.interviewId },
        "GET"
      )
        .then(response => {
          if (response.code == 200) {
            this.data = response.data;
          } else {
            this.error =
              "未能获取面试信息：" + (response.message || "未知错误");
          }
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
        });
    },
    confirmInterview() {
      this.req(
        "/party/acceptInvite",
        { interviewId: this.$route.query.interviewId },
        "GET"
      ).then(response => {
        if (response.code == 200) this.$message.success("面试邀请已确认");
        else this.$message.error("面试邀请确认失败：" + response.message);
      });
    },
    req(url, params, method) {
      // const path = "http://192.168.3.26:7601";
      const path = "https://api.abopin.com/hire";
      return new Promise((resolve, reject) => {
        $.ajax({
          url: `${path}${url}`,
          data: params,
          method: method,
          dataType: "json",
          success: response => {
            resolve(response);
          },
          error: (xhr, status, error) => {
            reject(error);
          }
        });
      });
    }
  }
};
</script>

<style scoped>
.interview-invite {
  min-height: 100vh;
  background: #f5f7fa;
  font-size: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.container {
  width: 90vw;
  max-width: 600px;
  margin: 0 auto;
  background: white;
  padding: 25px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  overflow-x: hidden;
  word-break: break-word;
}

.header {
  text-align: center;
  margin-bottom: 25px;
}

.header h2 {
  margin-bottom: 10px;
  color: #2c3e50;
  font-size: 1.25rem;
}

.header p {
  color: #7f8c8d;
  font-size: 0.9rem;
}

.info-card {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  gap: 18px;
}

.info-row {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 10px;
  padding: 10px 0;
  border-bottom: 1px solid #edf2f7;
}

.label {
  min-width: 120px;
  color: #5a6e7d;
  font-weight: 500;
  font-size: 14px;
}

.value {
  color: #2d373f;
  font-weight: 500;
  font-size: 1rem;
}

.confirm-btn {
  background: #42b983;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 6px;
  font-size: 16px;
  cursor: pointer;
  transition: background 0.3s;
  width: fit-content;
  margin: 0 auto;
  min-height: 48px;
  min-width: 120px;
}

.confirm-btn:hover {
  background: #318f63;
}

.loading {
  text-align: center;
  padding: 20px;
  color: #7f8c8d;
}

.error {
  text-align: center;
  padding: 20px;
  color: #e74c3c;
  background: #fee0e0;
  border-radius: 8px;
  margin-top: 15px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .label {
    min-width: auto;
    margin-bottom: 6px;
    font-size: 14px;
  }

  .info-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
  }

  .value {
    font-size: 15px;
  }

  .confirm-btn {
    width: 100%;
    padding: 14px;
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/accept-interview/accept-interview.vue